export const GOOGLE_MAPS_API = 'AIzaSyC5cmT5XIz2apKrEDYUfjwadxgGXmEaFcg';